import React from 'react'
import Icon from "./../static/icon"
import styles from "./radioCheckButton.module.scss"

const RadioCheckButton = props => {
  const { isChecked, onClick, icon } = props;

  let buttonIcon;

  if (icon) {
    buttonIcon = <div className={styles.emojiIconWrapper}><img className={styles.emojiIcon} src={`${icon}`}/></div>
  } 

  return (
    <button className={`${isChecked ? styles.radioCheckButtonChecked : styles.radioCheckButton} ${icon ? styles.radioCheckButtonWithEmoji : ''} `} onClick={onClick}>

      {buttonIcon}
      {props.children}

      <svg className={styles.icon} width="8" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" d="M5.318 7.073L.326 2.365a1.008 1.008 0 010-1.485c.435-.41 1.14-.41 1.575 0l5.773 5.445c.218.205.326.474.326.743.003.272-.106.545-.326.753L1.9 13.265c-.435.41-1.14.41-1.575 0a1.008 1.008 0 010-1.485l4.992-4.707z" fill="#000"/>
      </svg>
    </button>
  )
}

export default React.memo(RadioCheckButton)